import { useEffect, useState, useRef } from 'react';
import { apiHolder, apis } from 'api';
export const productAuthApi = apiHolder.api.requireLogicalApi(apis.productAuthApiImpl);
const defaultProductVersionInfo = {
    productId: '',
    productVersionId: 'others',
    showVersionTag: false,
    productVersionName: '',
    navigateVersion: false,
};
export function useGetProductAuth() {
    const [productAuthTagInfo, setProductAuthTagInfo] = useState(productAuthApi.doGetProductAuthTagsSync() || []);
    const [productVersionInfo, setProductVersionInfo] = useState(productAuthApi.doGetProductInfo() || Object.assign({}, defaultProductVersionInfo));
    const isMountedRef = useRef(true);
    useEffect(() => {
        isMountedRef.current = true;
        const fetchData = async () => {
            try {
                const [tags, version] = await Promise.all([productAuthApi.doGetProductAuthTags(), productAuthApi.doGetProductVersion()]);
                if (isMountedRef.current) {
                    setProductAuthTagInfo(tags);
                    setProductVersionInfo(version);
                }
            }
            catch (error) {
                console.error('Failed to fetch product auth data:', error);
            }
        };
        fetchData();
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    return {
        productVersionInfo,
        productAuthTagInfo,
    };
}
export function useShouldProductAuthTagDisplay(tagName) {
    const tagNames = Array.isArray(tagName) ? tagName : [tagName];
    const { productAuthTagInfo } = useGetProductAuth();
    return productAuthTagInfo.some(t => tagNames.includes(t.tagName) && t.needDisplay);
}
